// components/FullScreenLoader.jsx
import { Spin } from "antd";
import styles from "./loader.module.css"

const FullScreenLoader = ({ spinning }) => {
  if (!spinning) return null;
  return (
    <div className={styles.fullScreenLoader}>
      <Spin size="large" tip="Loading..." />
    </div>
  );
};

export default FullScreenLoader;
